
import { useState, useEffect } from "react";
import { CollapsibleContent } from "@/components/ui/collapsible";
import RequirementsList from "../requirement-item/RequirementsList";
import { PartFilter } from "@/data/parts";

interface RequirementsCollapsibleContentProps {
  requiresRoot: boolean;
  requiresWiring?: boolean;
  requiresPrinting?: boolean;
  requiresTools?: boolean;
  requiresPurchase?: boolean;
  printedParts?: string;
  hasShoppingLinks: boolean;
  subcategory: string;
  activeFilters?: PartFilter[];
  onFilterToggle?: (filter: PartFilter) => void;
}

const RequirementsCollapsibleContent = ({
  requiresRoot,
  requiresWiring = false,
  requiresPrinting = false,
  requiresTools = false,
  requiresPurchase = false,
  printedParts,
  hasShoppingLinks,
  subcategory,
  activeFilters = [],
  onFilterToggle
}: RequirementsCollapsibleContentProps) => {
  // State for badge active feedback
  const [activeBadge, setActiveBadge] = useState<PartFilter | null>(null);
  
  // Function to toggle filter with visual feedback
  const handleFilterToggle = (filter: PartFilter) => {
    if (onFilterToggle) {
      onFilterToggle(filter);
      // Set active badge for visual feedback
      setActiveBadge(filter);
      // Reset after animation completes
      setTimeout(() => setActiveBadge(null), 300);
    }
  };

  return (
    <CollapsibleContent className="mt-2 bg-muted/10 p-2 rounded-md">
      <RequirementsList
        requiresRoot={requiresRoot}
        requiresWiring={requiresWiring}
        requiresPrinting={requiresPrinting}
        requiresTools={requiresTools}
        requiresPurchase={requiresPurchase}
        printedParts={printedParts}
        hasShoppingLinks={hasShoppingLinks}
        subcategory={subcategory}
        activeFilters={activeFilters}
        activeBadge={activeBadge}
        onFilterToggle={handleFilterToggle}
      />
    </CollapsibleContent>
  );
};

export default RequirementsCollapsibleContent;
